import { defineMessages } from 'react-intl';
export default defineMessages({
  actionVerifying: {
    id: 'action.Verifying',
    defaultMessage: '验证中...',
  },
  actionverifyFailed: {
    id: 'action.verifyFailed',
    defaultMessage: '手机验证失败',
  },
  actionrequestFailed: {
    id: 'action.requestFailed',
    defaultMessage: '请求数据失败',
  },
  actioncannotSendVerifyCode: {
    id: 'action.cannotSendVerifyCode',
    defaultMessage: '不能发送验证码：',
  },
  actionsubmitOrder: {
    id: 'action.submitOrder',
    defaultMessage: '提交订单中...',
  },
  actionconfirmOrderFailed: {
    id: 'action.confirmOrderFailed',
    defaultMessage: '确认订单失败！！',
  },
  actiongetBandInfoFailed: {
    id: 'action.getBandInfoFailed',
    defaultMessage: '获取品牌门店信息失败...',
  },
  actiongetBaseInfoFailed: {
    id: 'action.getBaseInfoFailed',
    defaultMessage: '获取基本信息失败...',
  },
  actionsendVerityCodeFailed: {
    id: 'action.sendVerityCodeFailed',
    defaultMessage: '验证码发送失败',
  },
  actionsendVerifyCodeSuccess: {
    id: 'action.sendVerifyCodeSuccess',
    defaultMessage: '验证码发送成功注意查收',
  },
  actionLoading: {
    id: 'action.Loading',
    defaultMessage: '加载中...',
  },
  actioncannotFindShopId: {
    id: 'action.cannotFindShopId',
    defaultMessage: '找不到门店号',
  },
  actiongetPersonalInfoFailed: {
    id: 'action.getPersonalInfoFailed',
    defaultMessage: '获取个人基本信息失败',
  },
  actionbindPNFailed: {
    id: 'action.bindPNFailed',
    defaultMessage: '绑定手机失败',
  },
  actionbindWXFailed: {
    id: 'action.bindWXFailed',
    defaultMessage: '绑定微信失败',
  },
  actionbindAlipayFailed: {
    id: 'action.bindAlipayFailed',
    defaultMessage: '绑定支付宝失败',
  },
  actionactivateVipFailed: {
    id: 'action.activateVipFailed',
    defaultMessage: '激活会员卡失败',
  },
  actioninfoGetFailed: {
    id: 'action.infoGetFailed',
    defaultMessage: '信息获取失败',
  },
  actiongradeFailed: {
    id: 'action.gradeFailed',
    defaultMessage: '评分失败',
  },
  actionchangeUrlFailed: {
    id: 'action.changeUrlFailed',
    defaultMessage: '转化url失败',
  },
  actiongetTableInfoFailed: {
    id: 'action.getTableInfoFailed',
    defaultMessage: '获取桌台信息失败',
  },
  actiongetUseableTableFailed: {
    id: 'action.getUseableTableFailed',
    defaultMessage: '获取可用桌台信息失败',
  },
  actiongetInterfaceFailed: {
    id: 'action.getInterfaceFailed',
    defaultMessage: '获取接口失败',
  },
  actionOrderCenterFailed: {
    id: 'action.OrderCenterFailed',
    defaultMessage: '订单中心业务开关接口失败',
  },
  actioncannotFindCookerId: {
    id: 'action.cannotFindCookerId',
    defaultMessage: '找不到厨师ID',
  },
  actionsaveAddressFailed: {
    id: 'action.saveAddressFailed',
    defaultMessage: '保存收货地址失败',
  },
  actiondeleteAddressFailed: {
    id: 'action.deleteAddressFailed',
    defaultMessage: '删除收货地址失败',
  },
  actioncannotBindCard: {
    id: 'action.cannotBindCard',
    defaultMessage:
      '无法绑定该卡，请检查您输入的卡号和密码。如遇问题，请联系海底捞顾客关怀中心4008107107',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/action/part1/index.js